import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import PromotionView from '../views/PromotionView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // {
  //   path: '/home',
  //   name: 'home',
  //   component: HomeView
  // },
  // {
  //   path: '/promotion',
  //   name: 'promotion',
  //   component: PromotionView
  // }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
